import React, {useContext, useState} from 'react'

import { Modal } from '../../UI/Modal'
import { ModalTitle } from '../../UI/ModalTitle'
import { ModalButton } from '../../UI/ModalButton'
import { ModalContent } from '../../UI/ModalContent'
import { ModalButtons } from '../../UI/ModalButtons'

import { FeedbackForm } from '../FeedbackForm'

import { useFeedbackModalContext } from './context'

import { sendFeedbackApi } from '../../api/feedbackFormApi'
import {WebSocketsSharedContext} from '../../integrations/WebSockets'

export const FeedbackModal = props => {
  // TODO maybe better add and use react-hook-form
  const [isError, setIsError] = useState(false)
  const [sendData, setSendData] = useState({})
  const { setIsOpenFeedbackModal, feedbackConfigs } = useFeedbackModalContext()
  const { handleResetChat } = useContext(WebSocketsSharedContext)

  const handleChange = (field, value) => {
    setSendData({
      ...sendData,
      [field]: value,
    })
  }

  const onSubmit = () => {
    if (!sendData.score) {
      setIsError(true)
      return
    }
    const body = {
      type: feedbackConfigs.type,
      chatId: +props.chatId,
      ...sendData,
    }

    sendFeedbackApi(props.botId, body)

    if (
      feedbackConfigs.postAction === 'CLOSE_WIDGET' ||
      !feedbackConfigs.postAction
    ) {
      handleResetChat()
    }
    if (feedbackConfigs.postAction === 'CONTINUE_CHAT') {
      onClose()
    }
  }

  const onClose = () => {
    if (
      feedbackConfigs.postAction === 'CLOSE_WIDGET'
    ) {
      handleResetChat()
    }
    setIsOpenFeedbackModal(false)
  }

  return (
    feedbackConfigs && (
      <Modal>
        <ModalTitle>{feedbackConfigs.text}</ModalTitle>
        <ModalContent>
          <FeedbackForm
            isError={isError}
            setIsError={setIsError}
            setSendData={setSendData}
            handleChange={handleChange}
            commentInputPlaceholder={feedbackConfigs.placeholder}
          />
        </ModalContent>
        <ModalButtons>
          <ModalButton variant="cancel" onClick={onClose}>
            {feedbackConfigs.cancelButton}
          </ModalButton>
          <ModalButton variant="primary" onClick={onSubmit}>
            {feedbackConfigs.sendButton}
          </ModalButton>
        </ModalButtons>
      </Modal>
    )
  )
}
